import { useDebugValue, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { showSwalError, showSwalSuccess } from "utils/swal";
import DatePicker from "react-multi-date-picker";
import { FaPlusCircle } from "react-icons/fa";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import sendRequest from "hooks/useAxios";
import CreatableSelect from "react-select/creatable";
import { ImArrowLeft2 } from "react-icons/im";
import Filter from "./Filter";
import axios from "axios";
import { $ } from "jquery";

export default function Modals({
  SelectedUserInformation,
  updateFilteredUsers,
  users,
  EditUser,
  changeStatus,
  chosenPeople,
  Update,
  Tab,
  Access,
  Citys,
  UserAccess,
  setUserAccess,
  FirstAccess,
  Labels,
  setUpdater,
  Updater,
  SendMessage
}) {
  const [State, setState] = useState(2);
  const [AddTags, setAddTags] = useState([]);
  const [DelTags, setDelTags] = useState([]);
  const [flag, setFlag] = useState(true);
  const [Text, setText] = useState("");
  const [img, setimg] = useState("");
  const [key, setkey] = useState(0);
  const [keyDel, setkeyDel] = useState(0);
  const [SendMg, setSendMg] = useState({
    msgtxt: "",
    needsms: false,
    needemail: false
  });

  function UpdateAccess(value, id) {
    // let array = [...UserAccess];
    // if (value) {
    //   setUserAccess([...UserAccess, id]);
    // } else {
    //   array.splice(array.indexOf(id), 1);
    //   setUserAccess(array);
    // }
  }

  const sendAccessLevel = id => {
    FirstAccess.map(item => {
      if (!UserAccess.includes(item)) {
        let form = new FormData();
        form.append("conditions", `access_level_id/=/${item}@@user_id/=/${id}`);
        sendRequest("Delete_user_acl_links", form)
          .then(({ data }) => {
            if (!data.status) {
              Swal.fire(
                "مشکلی در ویرایش سطح دسترسی کاربر پیش آمده است",
                "",
                "warning"
              );
            }
          })
          .catch(error => {});
      }
    });

    UserAccess.map(item => {
      if (!FirstAccess.includes(item)) {
        let form = new FormData();
        form.append("user_id", `${id}`);
        form.append("access_level_id", `${item}`);
        sendRequest("Insert_user_acl_links", form)
          .then(({ data }) => {
            if (!data.status) {
              Swal.fire(
                "مشکلی در ویرایش سطح دسترسی کاربر پیش آمده است",
                "",
                "warning"
              );
            }
          })
          .catch(error => {});
      }
    });
  };

  const SendUsersTag = (Add, Del, SelectPeople) => {
    console.log(Add);
    let str = [];
    if (Add != "") {
      Add.map((item, index) => {
        //TODO : new tag should add to database and get id but it doesn't work
        if (item.__isNew__) {
          console.log(item, "tad id");

          let form = new FormData();
          let TagId = "";
          form.append("title", `${item.label}`);
          axios
            .post("http://marketgroup.tatdemo.ir/api/Insert_user_tags", form)
            .then(({ data }) => {
              if (data.status) {
                TagId = data.result.id;
                if (index == Add.length - 1) {
                  console.log(TagId, "tad id in it");
                  str += `${item.label},${parseInt(TagId)}`;
                } else {
                  str += `${item.label},${parseInt(TagId)}@@`;
                }
              }
            })
            .catch(error => {});
        }
        if (index == Add.length - 1) {
          str += `${item.label},${parseInt(item.value)}`;
        } else {
          str += `${item.label},${parseInt(item.value)}@@`;
        }
      });
    }
    console.log(str);
    SelectPeople.map(value => {
      if (Add != "") {
        let form = new FormData();
        form.append("tags", `${str}`);
        form.append("user_id", `${value[0]}`);
        sendRequest("save_link_user_tag", form)
          .then(({ data }) => {
            let Data = data.data;
            let Datakey = Object.keys(data.data);
            Datakey.map(item => {
              if (
                (!Data[item].status == "ok" || !Data[item].status == true) &&
                key == 0
              ) {
                setkey(1);
                showSwalError(
                  "مشکلی در افزودن تعدادی از برچسب ها  به وجود آمده"
                );
              }
            });
            if (key == 0) {
              showSwalSuccess("عملیات با موفقیت انجام شد");
            }
          })
          .catch(error => {});
      }
      if (Del != "") {
        Del.map(item => {
          let form = new FormData();
          form.append(
            "conditions",
            `user_tag_id/=/${item.value}@@user_id/=/${value[0]}`
          );
          sendRequest("Delete_user_tag_links", form)
            .then(({ data }) => {
              if (!data.status && keyDel == 0) {
                setkeyDel(1);
                showSwalError("مشکلی در حذف تعدادی از برچسب ها  به وجود آمده");
              }
            })
            .catch(error => {});
        });
      }
    });

    setUpdater(!Updater);
  };

  return (
    <>
      <div
        className="modal fade"
        id="edit-user"
        tabIndex={-1}
        aria-labelledby="edit-userLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data">
                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="profile-pic">
                      <div className="profile-pic position-relative">
                        <input
                          className="d-none"
                          type="file"
                          accept="image/*"
                          id="ProfilePic"
                          onChange={e => {
                            EditUser({
                              ...SelectedUserInformation,
                              ["profilepic"]: e.target.files[0]
                            });
                            setimg(URL.createObjectURL(e.target.files[0]));
                          }}
                        />
                        <img
                          src={
                            img == ""
                              ? `${"http://marketgroup.tatdemo.ir/" +
                                  SelectedUserInformation.url}`
                              : `${img}`
                          }
                          alt=""
                          style={{
                            width: "80px",
                            borderRadius: "50%",
                            height: "80px",
                            overflow: "hidden"
                          }}
                        />
                        <label
                          htmlFor="ProfilePic"
                          className="position-absolute text-dark"
                          style={{ right: "3px", top: "-10px" }}
                        >
                          <FaPlusCircle />
                        </label>
                      </div>
                    </label>
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="gender-edit-user" className="">
                      نوع
                    </label>

                    <select
                      className="form-select h-25"
                      value={SelectedUserInformation.type}
                      onChange={e => {
                        EditUser({
                          ...SelectedUserInformation,
                          ["type"]: e.target.value
                        });
                      }}
                      name="type"
                      id="type-edit-user"
                    >
                      <option value={0}>ادمین</option>
                      <option value={1}>مشتری</option>
                      <option value={2}>فروشگاه</option>
                      <option value={3}>مدیر رسته</option>
                    </select>
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="" htmlFor="name-edit-user">
                      نام{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control h-25"
                      id="name-edit-user"
                      value={SelectedUserInformation.fname}
                      onChange={e =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["fname"]: e.target.value
                        })
                      }
                      name="fname"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="" htmlFor="fullname-edit-user">
                      نام خانوادگی
                    </label>
                    <input
                      type="text"
                      className="form-control h-25"
                      value={SelectedUserInformation.lname}
                      onChange={e =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["lname"]: e.target.value
                        })
                      }
                      name="lname"
                      id="fullname-edit-user"
                    />
                  </div>
                  {/* 
                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="title" htmlFor="father-name-edit-user">
                      نام پدر
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={SelectedUserInformation.fathername}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["fathername"]: e.target.value,
                        })
                      }
                      name="fathername"
                      id="father-name-edit-user"
                    />
                  </div> */}

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="" htmlFor="national-code-edit-user">
                      کد ملی
                    </label>
                    <input
                      type="number"
                      className="form-control text-start h-25"
                      value={SelectedUserInformation.codemelli}
                      onChange={e =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["codemelli"]: e.target.value
                        })
                      }
                      name="codemeli"
                      id="national-code-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="address-edit-user" className="">
                      آدرس{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control h-25"
                      value={SelectedUserInformation.address}
                      onChange={e =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["address"]: e.target.value
                        })
                      }
                      name="address"
                      id="address-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="tell-edit-user" className="">
                      تلفن همراه{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control h-25"
                      value={SelectedUserInformation.mobile}
                      onChange={e =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["mobile"]: e.target.value
                        })
                      }
                      name="tell"
                      id="tell-edit-user"
                    />
                  </div>
                  {/* 
                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="city-edit-user" className="title">
                      شهر{" "}
                    </label>
                    <select
                      className="form-select"
                      id="city-edit-user"
                      name="cityid"
                      value={SelectedUserInformation.cityid}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["cityid"]: e.target.value,
                        })
                      }
                    >
                      {Citys.map((item) => (
                        <option
                          key={item.id}
                          value={item.id}
                          selected={
                            item.id == SelectedUserInformation.cityid
                              ? true
                              : false
                          }
                        >
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  {/* 
                  <div className="edit-user-item d-flex justify-content-between filter-modal">
                    <label htmlFor="birthdayts" className="title">
                      تاریخ تولد:
                    </label>

                    <DatePicker
                      id="birthdayts"
                      className="rmdp-prime w-100"
                      showOtherDays
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      name="birthdayts"
                      value={(SelectedUserInformation.bdyear == 0 || SelectedUserInformation.bdyear == "") && (SelectedUserInformation.bdday == 0 || SelectedUserInformation.bdday == "") && (SelectedUserInformation.bdmonth == 0 || SelectedUserInformation.bdmonth == "") ? "" : `${SelectedUserInformation.bdyear}/${SelectedUserInformation.bdmonth}/${SelectedUserInformation.bdday}`}
                      onChange={(dateObjects) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["bdday"]: dateObjects.day,
                          ["bdmonth"]: dateObjects.month,
                          ["bdyear"]: dateObjects.year,
                        })
                      }
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #cbc7c7",
                        borderRadius: "4px",
                      }}
                    />
                  </div> */}
                  {/* 
                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="gender-edit-user" className="title">
                      جنسیت
                    </label>

                    <select
                      className="form-select"
                      value={SelectedUserInformation.jender}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["jender"]: e.target.value,
                        })
                      }
                      name="sextype"
                      id="gender-edit-user"
                    >
                      <option value={0}>مرد</option>
                      <option value={1}>زن</option>
                    </select>
                  </div> */}

                  {/* <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="mtm" className="">
                      تاریخ عضویت
                    </label>
                    <DatePicker
                      id="mtm"
                      className="rmdp-prime"
                      showOtherDays
                      calendar={persian}
                      locale={persian_fa}
                      onClose={() => ""}
                      value={SelectedUserInformation.mtm * 1000}
                      onChange={(dateObjects) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["mtm"]: dateObjects.unix,
                        })
                      }
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #cbc7c7",
                        borderRadius: "4px",
                      }}
                      calendarPosition="bottom-right"
                      name="mtm"
                    />
                  </div> */}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(SelectedUserInformation);
                  setimg("");
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="access-level"
        tabIndex={-1}
        aria-labelledby="edit-userLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="edit-userLabel">
                سطح دسترسی
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {Access.map((item, index) =>
                [0, 1, 2, 4, 13, 14, 15, 16, 3].includes(
                  parseInt(item.mid)
                ) ? null : (
                  <div className="ms-3 d-flex align-items-center" key={item.id}>
                    <input
                      checked={UserAccess.includes(item.id)}
                      type="checkbox"
                      className="form-check form-check-inline"
                      id={`Access${item.id}`}
                      onChange={e => UpdateAccess(e.target.checked, item.id)}
                    />
                    <label
                      htmlFor={`Access${item.id}`}
                      className="form-check-label "
                    >
                      {item.title}
                    </label>
                  </div>
                )
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                onClick={() => {
                  sendAccessLevel(SelectedUserInformation.id);
                }}
                className="btn btn-primary"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="send-message"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                ارسال پیام
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className=" ">
                <label htmlFor="send-message-input1">پیام:</label>
                <textarea
                  required
                  id="send-message-input1"
                  className="form-control ms-2 mb-2"
                  value={SendMg.msgtxt}
                  onChange={e =>
                    setSendMg({ ...SendMg, ["msgtxt"]: e.target.value })
                  }
                ></textarea>

                <input
                  type="checkbox"
                  className="mx-2 form-check-input"
                  id="Email-Check"
                  value={SendMg.needemail ? true : false}
                  onChange={e =>
                    setSendMg({
                      ...SendMg,
                      ["needemail"]: e.target.checked ? 1 : 0
                    })
                  }
                />
                <label htmlFor="Email-Check" className="m-1">
                  ارسال ایمیل
                </label>
                <br />
                <input
                  type="checkbox"
                  className="mx-2 form-check-input"
                  id="SMS-Check"
                  value={SendMg.needsms ? true : false}
                  onChange={e =>
                    setSendMg({
                      ...SendMg,
                      ["needsms"]: e.target.checked ? 1 : 0
                    })
                  }
                />
                <label htmlFor="SMS-Check" className="m-1">
                  ارسال پیامک
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                onClick={() =>
                  SendMessage(
                    SendMg,
                    chosenPeople.length == 0
                      ? [
                          [
                            SelectedUserInformation.id,
                            SelectedUserInformation.email
                          ]
                        ]
                      : chosenPeople,
                    setSendMg
                  )
                }
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ارسال
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="toggle-status-modal"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                فعال / غیرفعال سازی کاربران{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="form-check form-switch ps-0">
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  فعال سازی کاربران:
                </label>
                <input
                  checked={State == 2 ? false : true}
                  className="form-check-input ms-1"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  style={{ float: "none" }}
                  onChange={e => setState(e.target.checked ? 1 : 2)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                onClick={() => changeStatus(chosenPeople, State, Tab)}
                className="btn btn-primary"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="change-label"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                برچسب{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center">
                <label htmlFor="add-label-input" style={{ width: "150px" }}>
                  افزودن برچسب:
                </label>

                <CreatableSelect
                  isMulti
                  placeholder={"انتخاب"}
                  options={Labels}
                  id="add-label-input"
                  className="text-dark group-change-label ms-2"
                  value={AddTags}
                  onChange={e => setAddTags(e)}
                />
              </div>
              <div className="d-flex align-items-center">
                <label
                  htmlFor="send-message-input me-2"
                  style={{ width: "150px" }}
                >
                  حذف برچسب:
                </label>

                <CreatableSelect
                  isMulti
                  placeholder={"انتخاب"}
                  options={Labels}
                  className="text-dark group-change-label ms-2"
                  isSearchable={false}
                  value={DelTags}
                  onChange={e => setDelTags(e)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                onClick={() => SendUsersTag(AddTags, DelTags, chosenPeople)}
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
